module.exports = __webpack_public_path__ + "assets/img/s3.f1ebb2d7.jpg";